export default defineNuxtPlugin(() => {
  if (import.meta.server) {
    return;
  }

  (function (d, s, id) {
    const fjs = d.getElementsByTagName(s)[0] as HTMLScriptElement | undefined;
    if (d.getElementById(id) || !fjs?.parentNode) {
      return;
    }
    const js = d.createElement(s) as HTMLScriptElement;
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "twitter-wjs");
});
